/*
  minidriftco: startet den Glanz-Effekt von Buttons, Badges und Sternen neu,
  sobald sie ins Bild scrollen - der erste Glanz kommt so sofort.
*/
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = [
    '.button:not(.button--tertiary)',
    '.shopify-payment-button__button',
    '.mdc-bundle__atc',
    '.mdc-bundle__ribbon',
    '.mdc-bundle__save-badge',
    '.badge',
    '.mdc-rl__stars span:not(.is-off)'
  ].join(',');

  function restart(el) {
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = '';
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) restart(entry.target);
      });
    },
    { threshold: 0.6 }
  );

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.__mdcShine) return;
      el.__mdcShine = true;
      observer.observe(el);
    });
  }

  // Neu geladene Inhalte (z. B. Warenkorb-Drawer) gebuendelt nachpruefen.
  var scanTimer = null;
  function scheduleScan() {
    if (scanTimer) return;
    scanTimer = setTimeout(function () {
      scanTimer = null;
      scan();
    }, 500);
  }

  scan();
  new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
})();
